<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card :title="$t('UsersList') |ToUppercase">

        <vs-button class="float-left" color="success" type="filled" to="/user/add">{{$t('UserAdd')}}</vs-button>

        <vs-table :noDataText="$t('NoUsersFound')" max-items="14" pagination search :data="users" @selected="handleSelected">
          <template slot="thead">
            <vs-th sort-key="id">
              #
            </vs-th>
            <vs-th sort-key="fullname">
              {{$t('Fullname') |ToUppercase}}
            </vs-th>
            <vs-th sort-key="username">
              {{$t('Username') |ToUppercase}}
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :state="tr.disabled == true?'dark':null" :data="tr" :key="data[index].id" v-for="(tr, index) in data">
              <vs-td>{{ data[index].id}}</vs-td>
              <vs-td>{{ data[index].fullname}}</vs-td>
              <vs-td>{{ data[index].username}}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: ""
    };
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  computed: {
    users() {
      return this.$store.state.admin.users.slice();
    }
  },
  created() {
    this.$store.dispatch("admin/fetchUsers");
  },
  methods: {
    handleSelected(tr) {
      this.$router.push(`/user/${tr.id}`);
    }
  }
};
</script>
